import { getApi } from "../../../services/apiBase";
import { configuration_get } from "../../../services/apiURL";
import { UPDATE_TABLE, ACCESS_LOCK, RESET_TABLE, UPDATE_PAGINATION, SET_DEFAULT_RECORDS_PER_PAGE} from "./types";

export const updateTable = (value) => async (dispatch) => {
    await dispatch({
        type: UPDATE_TABLE,
        payload: value
    });
};
export const resetTable = (value) => async (dispatch) => {
    await dispatch({
        type: RESET_TABLE,
        payload: value
    });
};

export const accessLock = (value) => async (dispatch) => {
    await dispatch({
        type: ACCESS_LOCK,
        payload: value
    });
};

export const updatePagination = (value) => async (dispatch) => {
    await dispatch({
        type: UPDATE_PAGINATION,
        payload: value
    });
};

export const setDefaultRecordsPerPage = (value) => async (dispatch) => {
    const { defaultRecordsToShow } = value;
    dispatch({
        type: SET_DEFAULT_RECORDS_PER_PAGE,
        payload: defaultRecordsToShow
    })
};